/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_Requirements_PendingInputs */

const en_mk_desktop_requirements_pending = /** @type {(inputs: Mk_Desktop_Requirements_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.tgz archive. The latest version is in the download list.`)
};

const id_mk_desktop_requirements_pending = /** @type {(inputs: Mk_Desktop_Requirements_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arsip .tgz. Versi terbaru ada di daftar unduhan.`)
};

/**
* | output |
* | --- |
* | ".tgz archive. The latest version is in the download list." |
*
* @param {Mk_Desktop_Requirements_PendingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_requirements_pending = /** @type {((inputs?: Mk_Desktop_Requirements_PendingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_Requirements_PendingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_requirements_pending(inputs)
	return en_mk_desktop_requirements_pending(inputs)
});